import { Link } from "react-router-dom";

const FOOTER_LINKS = [
  { label: "首页", to: "/" },
  { label: "电影频道", to: "/category/movies" },
  { label: "电视剧频道", to: "/category/tv" },
  { label: "搜索影视", to: "/search" },
  { label: "关于我们", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100 md:mt-24">
      <div className="page-shell grid grid-cols-1 gap-8 py-12 sm:grid-cols-2 md:py-16 lg:grid-cols-4">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-lg text-primary-950">
              <i className="ri-film-line" aria-hidden="true"></i>
            </span>
            <span className="font-heading text-xl font-extrabold text-background-50">新金瓶梅</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
            专注电影与电视剧的作品资讯、剧情介绍与相关资源展示，为影视爱好者提供清晰、可靠的浏览体验。
          </p>
          <p className="mt-4 text-xs text-background-400">
            站内所有影视作品与人物均为示例数据，用于演示展示效果。
          </p>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">
            快速导航
          </h3>
          <ul className="mt-4 space-y-2.5">
            {FOOTER_LINKS.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm text-background-300 transition-colors hover:text-accent-400"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">
            联系我们
          </h3>
          <ul className="mt-4 space-y-2.5 text-sm text-background-300">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-accent-400" aria-hidden="true"></i>
              <a href="mailto:hello@xinjinpingmei.example" className="transition-colors hover:text-accent-400">
                hello@xinjinpingmei.example
              </a>
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-customer-service-2-line text-accent-400" aria-hidden="true"></i>
              <Link to="/about" className="transition-colors hover:text-accent-400">
                内容反馈入口
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="page-shell flex flex-col gap-3 py-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 新金瓶梅影视资源与剧情介绍平台 · 保留所有权利</p>
          <p>本站内容仅供信息展示与交流，不提供任何影视播放或下载服务。</p>
        </div>
      </div>
    </footer>
  );
}